import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/times-circle.svg'
import _imports_1 from '../assets/icons/angle-left.svg'
import _imports_2 from '../assets/icons/angle-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-dda4a0da"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "close-button"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import { Context, Action } from '../struct'
import { ref, computed, onMounted, nextTick, onBeforeUnmount } from 'vue'


export default {
  __name: 'ContextPicker',
  props: {
  action: {
    type: String,
    default: Action.Any
  },
  modelValue: { }
},
  emits: ['update:modelValue', 'close'],
  setup(__props, { emit: emits }) {

const props = __props;





const displayItems = ref(false)

const page = ref(0)

const choices = computed(() => {
  if (props.action === Action.Any) {
    return [
      ['Air', 'Air'],
      ['Air', 'Contact'],
      ['Contact', 'Air'],
      ['Contact', 'Contact'],
      ['Contact'],
      ['Air'],
      ['Any', 'Any'],
      ['Any']
    ]
  } else if (props.action === Action.Still) {
    return [['Air'], ['Contact'], ['Any']]
  } else {
    return [['Air', 'Air'], ['Air', 'Contact'], ['Contact', 'Air'], ['Contact', 'Contact'], ['Contact'], ['Any', 'Any'], ['Any']]
  }
})

function contextToImg (context) {
  if (!context) return []
  const temp = []
  for (const ctx of context) {
    switch (ctx) {
      case Context.Air:
        temp.push(require('../assets/glyphs/Air.svg'))
        break
      case Context.Contact:
        temp.push(require('../assets/glyphs/Contact.svg'))
        break
      case Context.Any:
        temp.push(require('../assets/glyphs/Any.svg'))
        break
      default:
    }
  }
  return temp
}

function emitChoice (choice) {
  emits('update:modelValue', choice)
}

onMounted(() => {
  nextTick(() => {
    displayItems.value = true
  })
})

onBeforeUnmount(() => {
  displayItems.value = false
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "context-picker",
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => (emits('close')), ["stop"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(choices).slice(page.value*6, page.value*6 + 6).entries(), ([i, choice]) => {
      return (_openBlock(), _createElementBlock("button", {
        key: i,
        onClick: () => emitChoice(choice),
        class: _normalizeClass(['menu-item', (displayItems.value) ? 'display' : '', (JSON.stringify(choice) === JSON.stringify(__props.modelValue)) ? 'selected' : ''])
      }, [
        (contextToImg(choice).length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(contextToImg(choice).entries(), ([j, src]) => {
              return (_openBlock(), _createElementBlock("img", {
                key: j,
                src: src
              }, null, 8, _hoisted_2))
            }), 128))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    }), 128)),
    _hoisted_3,
    (Math.ceil(_unref(choices).length / 6) > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "pages-button",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => (page.value--), ["stop","prevent"])),
            class: _normalizeClass(page.value === 0 ? 'hide' : '')
          }, _hoisted_5, 2),
          _createElementVNode("span", null, _toDisplayString(page.value + 1) + " | " + _toDisplayString(Math.ceil(_unref(choices).length / 6)), 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => (page.value++), ["stop","prevent"])),
            class: _normalizeClass(page.value === 2 ? 'hide' : '')
          }, _hoisted_7, 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}